module.exports = "img/chevron.dc904f3.png";